<script>
import Base from "@/components/RequestDetails/RequestLogNew.vue";

export default {
  name: "CustomerServiceRequestLogNew",
  extends: Base,
};
</script>

